import { Cdr } from '@reliance/types/models/Cdr';
import { IAuthToken } from '../models/auth';
import { IVisitationPending } from '../models/visitation';
import { IApiService, IPaginatedResponse } from '../services/api_service';
import config from '../services/config';
import connectServerService from '../services/connect_server_service';

export const visitation = (siteApi: IApiService, getToken: () => IAuthToken) => ({
  recordingPreviewUrl: (id) => {
    return `${config.api.url}/visitation/recording/${id}/preview?token=${getToken().accessToken}`;
  },
  index: (params): Promise<IVisitationPending[]> => {
    return siteApi.get('/visitation', { params });
  },
  post: (data) => {
    return siteApi.post('/visitation', data);
  },
  search: (params?): Promise<IPaginatedResponse<Cdr>> => {
    return siteApi.get('/visitation/search', { params });
  },
  delete: (id, note) => {
    connectServerService.send({
      route: 'web/visitation/terminate',
      payload: {
        visitationId: id,
        cause: 'OfficerTerminated'
      }
    });
    return siteApi.delete(`/visitation/${id}`, { params: { note } });
  },
  checkInVisitor: (id) => {
    return siteApi.put(`/visitation/check-in-visitor/${id}`);
  },
  pdfUrl: (params = {}): string => {
    return siteApi.buildUrl('/visitation/search.pdf', {
      ...params,
      token: getToken().accessToken
    });
  }
});
